import angular from 'angular';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import template from './campaignsExploreAxisSettings.jade';

export class CampaignsExploreAxisSettingsController {
  /* @ngInject */
  constructor($stateParams, $filter) {
    this.$stateParams = $stateParams;
    this.$filter = $filter;

    this.typeOptions = [
      {value: 'spline', icon: 'icon-chart-line:modal'},
      {value: 'column', icon: 'icon-chart-bar:modal'},
      {value: 'area',   icon: 'icon-chart-area:modal'}
    ];

    if (this.axisIndex == 0) {
      this.series.push(this.serieByAxisName(this.$stateParams.axisName));
      this.serieChange.onNext(this.series[this.axisIndex]);
    }
  }

  serieByAxisName(axisName) {
    return _.clone(this.seriesOptions[axisName]);
  }

  updateAxisSerie(seriesOption) {
    let axisName = seriesOption.seriesName || seriesOption.metric;
    let serie = this.serieByAxisName(axisName);

    if (this.axisIndex == this.series.length) {
      this.series.push(serie);
    } else {
      this.series[this.axisIndex] = serie;
    }
    this.serieChange.onNext(this.series[this.axisIndex]);
  }

  updateAxisType(type) {
    if (this.axisIndex > this.series.length-1)
      return;

    this.series[this.axisIndex].type = type;
    this.serieChange.onNext(this.series[this.axisIndex]);
  }

  canSelectType() {
    let serie = this.series[this.axisIndex];
    return serie && serie.type != 'pie';
  }

  canSelectSerieOption(serieOption) {
    if (this.axisIndex == 0) {
      return true;
    } else {
      return serieOption.type != 'pie'
    }
  }

  isActiveType(type) {
    return this.series[this.axisIndex].type == type;
  }
}

export function CampaignsExploreAxisSettingsComponent() {
  return {
    template,
    controller: CampaignsExploreAxisSettingsController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      series: '=',
      serieChange: '=',
      seriesOptions: '=',
      axisIndex: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.explore.axisSettings', [
  ServicesModule.name,
  ResourcesModule.name
])
  .directive('campaignsExploreAxisSettings', CampaignsExploreAxisSettingsComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsExploreAxisSettings.js
 **/